import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function InspectionSupport() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">이실장에서는 현장 확인이 필요없는 온라인 임장활동이 가능해요</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<ol className="list_order"><li><h4 className="order_num">Step 1</h4><p className="order_desc">내가 관리하는 아파트 단지의 개별호실별 점유형태, 등기정보 등이 한눈에 확인 가능해요</p><Image className="img_guide" src="/image/desktop/popup/inspection01_01.png" alt={"\uB0B4\uAC00 \uAD00\uB9AC\uD558\uB294 \uC544\uD30C\uD2B8 \uB2E8\uC9C0\uC758 \uAC1C\uBCC4\uD638\uC2E4\uBCC4 \uC810\uC720\uD615\uD0DC, \uB4F1\uAE30\uC815\uBCF4 \uB4F1\uC774 \uD55C\uB208\uC5D0 \uD655\uC778 \uAC00\uB2A5\uD574\uC694"} width={100} height={100} /></li><li><h4 className="order_num">Step 2</h4><p className="order_desc">각 개별호실을 클릭하면 고객/점유 정보부터 시세, 등기현황까지 확인이 가능해요</p><Image className="img_guide" src="/image/desktop/popup/inspection01_02.png" alt={"\uCDA9\uC804\uAE08\uC774 \uC801\uC6A9\uB418\uC5C8\uC5B4\uC694."} width={100} height={100} /></li></ol></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}